export const messages = {
  en: {
    userDetailOrder: {
      orderNo: 'Order No',
      platform: 'Platform',
      shop: 'Shop',
      type: 'Type',
      service: 'Service',
      product: 'Product',
      name: 'Name',
      quantity: 'Quantity',
      userName: 'User Name',
      paymentAmount: 'Payment Amount',
      orderStatus: 'Order Status',
      createTime: 'Create Time'
    }
  },
  zh: {
    userDetailOrder: {
      orderNo: '订单号',
      platform: '平台',
      shop: '商铺',
      type: '类型',
      service: '服务',
      product: '商品',
      name: '名称',
      quantity: '数量',
      userName: '用户名称',
      paymentAmount: '支付金额',
      orderStatus: '订单状态',
      createTime: '创建时间'
    }
  }
}